// Module
var code = `<div appHeaderBar>
    <header-bar-title>Property Details</header-bar-title>
</div>

<app-page-content [showWebFooter]="true" [usePagePadding]="true">
    <app-cobrand-header [property]="staticPropertyNickname" [manager]="property.hoa.pmc.name" [association]="property.hoa.name"></app-cobrand-header>

    <form name="Form" id="Form" class="form">
        <div class="HOA-container">
            <div class="HOA-container__header">
                <h1 class="HOA-container__header-text" tid="propertyDetailsHeader">Property Details</h1>
                <button name="moved" id="moved" tid="moved" type="button" class="Button Button--link" (click)="moved()">Have you moved?</button>
            </div>
            <div class="HOA-container__content">
                <div [ngClass]="{ 'is-invalid': propertyNicknameError }" class="Field HOA-card-flex-child-100 HOA-card-flex-offset-child-left">
                    <label for="propertyNickname" class="Field-label" tid="nicknameHeader">
                        Property Nickname
                        <span class="asterisk-required">&nbsp;&#42;</span>
                    </label>

                    <input type="text" class="Input" id="propertyNickname" tid="propertyNickname" name="propertyNickname" [(ngModel)]="nickname" (change)="propertyNickname()" aria-invalid="propertyNicknameError" attr.aria-describedby="{{propertyNicknameError && 'propertyNickname-error' || undefined }}" maxlength="100">
                    <span class="Field-error" id="propertyNickname-error" tid="nicknameError">Please enter a property nickname.</span>
                </div>
                <div class="HOA-flextable-component__subheader u-mT3 u-mB7" tid="propertyDetailsSubHeader">
                    Property Details
                </div>
                <app-address-form
                    [property]="property"
                    [disableInputsAddress]="disableInputsAddress"
                    (defaultNickname)="defaultNickname()"
                    [showPropertyNickname]="false"
                    (invalidCheck)="invalidCheck(\$event.invalidObj)"
                    [setPropertyAddressEvent]="setPropertyAddressSubject.asObservable()">
                </app-address-form>
                <div class="HOA-flex-component HOA-flex-component-sm-col-lg-row">
                    <app-property-form-left [anonymous]="false" (blurFunction)="checkIfMoved()" [disableInputsProperty]="disableInputsProperty"
                                            [disablePropertyId]="disablePropertyId" class="HOA-flextable-component__form-vertical HOA-flextable-component__cell--alt50 HOA-flextable-component__form--left
                                        HOA-flextable-component__form" (invalidCheck)="invalidCheck(\$event.invalidObj)" [property]="property"></app-property-form-left>
                    <div class="HOA-guest-payment-padding-helper HOA-flextable-component__cell--alt50 HOA-flextable-component__form--right">
                        <!-- This needs to stay so that the left stays correctly -->
                    </div>
                </div>
                <div class="HOA-Checking-Detail-button-container">
                    <button name="cancel" id="cancel" tid="cancel" type="button" class="Button Button--link" (click)="cancel()">Cancel</button>
                    <button name="submitSave" id="submitSave" tid="submitSave" type="submit" class="Button Button--blue" [disabled]="invalid()" (click)="preSave()">
                        <div [ngClass]="{'u-visibility-hidden': !isLoadingFindMyProperty}" class="HOA-absolutelyCentered">
                            <div class="spinner spinner--small"><div *ngFor="let i of [1,2,3,4,5,6,7,8,9,0]"></div></div>
                        </div>
                        <span [ngClass]="{'u-visibility-hidden': isLoadingFindMyProperty}" tid="saveLabel">Save</span>
                    </button>
                </div>
                <div class="u-pT2 HOA-flex-component HOA-font-fine-print" tid="finePrint"><span class="asterisk-required">&#42;</span>&nbsp;Indicates required field</div>
            </div>
        </div>
    </form>
    <div class="HOA-remove-button-container">
        <button name="submitDelete" id="submitDelete" tid="submitDelete" type="submit" class="Button Button--outline" (click)="removeProperty()">Delete Property</button>
    </div>
</app-page-content>`;
// Exports
module.exports = code;